export const SUPERUSER = "super-user";
export const ADMIN = "admin";
export const RESELLER = "reseller";